$(function(){
  let wrapperEls = $('[data-moderation]');
  wrapperEls.each(function() {
    let wrapperEl       = $(this);
    let buttonEl        = wrapperEl.find('.estate-moderation__button .btn');
    let selectEl        = wrapperEl.find('.estate-moderation__select select');
    let adminEl         = wrapperEl.closest('.estate-admin'); 
    let statusEl        = adminEl.find('[data-estate-status]');
    let statusContentEl = statusEl.find('.estate-admin__status-content');
 
    
    // update moderation status
    buttonEl.on('click', function(){
      // clear status on update
      statusEl.removeClass('success').removeClass('error');
      statusContentEl.html('');

      $.ajax({
        url: ajaxurl,
        dataType: 'json',
        type: 'post',
        data: {
          action: 'realty_moderation_change',
          realty_id: +wrapperEl.attr('data-realty-id'),
          data: {
            moderation: selectEl.val()
          }
        }
      }).done((response) => {
        if(response.success) {
          statusEl.addClass('success');
          statusContentEl.html('Модерация успешно обновлена');
        }
        else {
          statusEl.addClass('error');
          statusContentEl.html(response.error);
        }
      }).error((error) => {
        console.log(error);
        statusEl.addClass('error');
        statusContentEl.html('Произошла непредвиденная ошибка');
      });
    });
  });
});